import { useSelector } from 'react-redux'

export function useApplicationQueueSelector() {
  return useSelector((state: any) => state.applicationQueue)
}

// New selector for O(1) lookup by assignee
export function useAssignmentQueueByAssignee(assignee: string) {
  return useSelector(
    (state: any) => state.applicationQueue.assignmentQueuesMap[assignee]
  )
}
